<template>
  <div>
    <el-table
      ref="table"
      v-loading="loading"
      :data="items"
      border
      fit
      highlight-current-row
      style="width: 100%"
      height="600"
      @row-dblclick="onTableRowDoubleClick"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" min-width="55"> </el-table-column>

      <el-table-column :label="$t('common.description')" min-width="150" sortable property="description">
        <template slot-scope="scope">
          <span>{{ scope.row.description }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.productType')" min-width="200" sortable property="productTypeDescription">
        <template slot-scope="scope">
          <span>{{ scope.row.productTypeDescription }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.ean')" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.ean }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('domain.domainCode')" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.domainCode }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('domain.domainDescription')" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.domainDescription }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('domain.priceDescription')" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.priceDescription }}</span>
        </template>
      </el-table-column>
    </el-table>

    <dialog-editor
      ref="dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :definition="definition"
      :page-loading="loading"
      prevent-default
      :force-values="parentIdentifierObject"
      v-bind="editorProps"
    >
      <base-button type="primary" :caption="$t('common.ok')" :icon-only="false" @click="handleDialogSave" />
    </dialog-editor>
  </div>
</template>

<script>
import DialogEditor from '@/components/crud/DialogEditor';
import BaseButton from '@/components/crud/BaseButton';
import { getFormDefinition } from './domainproduct';
export default {
  name: 'ProductList',
  components: {
    DialogEditor,
    BaseButton
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      editorProps: {},
      dialogTitle: '',
      selectedRows: []
    };
  },
  computed: {
    definition() {
      return getFormDefinition(this);
    },
    items() {
      return this.$store.getters['product/loadedItems'];
    },
    loading() {
      return this.$store.getters['product/isLoading'];
    },
    parentID() {
      return this.$route.params && +this.$route.params.id;
    },
    parentIdentifierObject() {
      const obj = {};
      obj[this.parentIdFilterField] = this.parentID;
      return obj;
    }
  },
  watch: {
    value(value) {
      this.updateTableSelection();
    },
    items(items) {
      this.updateTableSelection();
    }
  },
  created() {
    const params = {
      query: {
        ownProductYN: true,
        withFabrics: true
      }
    };
    this.$store.dispatch('product/getItems', params);
  },
  methods: {
    handleDialogSave() {
      if (this.$refs.dialog) {
        this.$refs.dialog.saveForm();
      }
    },
    updateTableSelection() {
      this.value.forEach(product => {
        const productRow = this.items.find(item => item.id === product.productID);
        if (productRow) {
          this.copyProductToRow(product, productRow);
          this.ignoreSelectionChange = true;
          this.selectRow(productRow);
        }
      });
      this.ignoreSelectionChange = false;
    },
    emitValue(value) {
      this.$emit('input', value);
    },
    selectionHasChanged(newSelections) {
      return (
        this.selectedRows.length === newSelections.length &&
        !this.selectedRows.some(row => !newSelections.find(v => v.id === row.id))
      );
    },
    handleSelectionChange(val) {
      if (this.ignoreSelectionChange) {
        return;
      }
      if (this.selectionHasChanged(val)) {
        return;
      }
      const emittedValues = val.map(item => this.transformRowToProduct(item));
      this.selectedRows = val;
      this.emitValue(emittedValues);
    },
    onTableRowDoubleClick(row) {
      this.showDialog(row);
    },
    triggerUpdate(row) {
      this.deselectRow(row);
      this.selectRow(row);
    },
    showDialog(row) {
      if (this.disabled) {
        return false;
      }
      this.editorProps = {
        isEdit: true,
        fetchById: () => Promise.resolve(row),
        save: form => {
          if (form) {
            this.$set(row, 'domainCode', form.domainCode);
            this.$set(row, 'domainDescription', form.domainDescription);
            this.$set(row, 'priceListItemID', form.priceListItemID);
            this.triggerUpdate(row);
          }
          this.dialogVisible = false;
        }
      };
      this.dialogVisible = true;
    },
    deselectRow(row) {
      this.$refs.table.toggleRowSelection(row, false);
    },
    selectRow(row) {
      this.$refs.table.toggleRowSelection(row, true);
    },
    copyProductToRow(product, row) {
      row.domainCode = product.code;
      row.domainDescription = product.description;
      row.priceListItemID = product.priceListItemID;

      const price = this.$store.getters['priceListItem/loadedItems'].find(pli => pli.id === product.priceListItemID);
      row.priceDescription = price ? price.description : '';
    },
    transformRowToProduct(row) {
      const product = {
        productID: row.id,
        code: row.domainCode,
        description: row.domainDescription,
        priceListItemID: row.priceListItemID
      };
      return product;
    }
  }
};
</script>
